import React from "react"

import { trackEvent } from "../../utils/tracking"

export function resourceUrl(url) {
  if (!url) return ""
  if (url.includes("?")) {
    return `${url}&utm_source=thehiveindex.com`
  }
  return `${url}?utm_source=thehiveindex.com`
}

/**
 * Topic sidebar card for curated resources (dofollow links).
 * Only render when `resources` is non-empty.
 */
const Resources = ({ resources, topic, location = "Topic" }) => {
  if (!resources || !resources.length) {
    return null
  }

  return (
    <section aria-labelledby="topic-resources-heading" data-nosnippet>
      <div className="rounded-lg bg-white p-6 shadow">
        <h2
          id="topic-resources-heading"
          className="text-base font-medium text-gray-900"
        >
          {topic.name} Resources
        </h2>

        <div className="mt-3 flex flex-col gap-4">
          {resources.map(resource => {
            const href = resourceUrl(resource.url)
            if (!href) return null

            const onClick = () => {
              trackEvent("ResourceClick", {
                key: resource.key,
                name: resource.name,
                url: resource.url,
                topic: resource.topic || (topic && topic.slug) || "",
                descriptor: resource.descriptor,
                order: resource.order,
                location,
              })
            }

            return (
              <a
                key={resource.key || resource.name}
                href={href}
                target="_blank"
                rel="noopener dofollow"
                onClick={onClick}
                className="-mx-2 block rounded-md px-2 py-1.5 hover:bg-gray-50"
              >
                <span className="block font-medium text-rose-500">
                  {resource.name}
                </span>
                {resource.descriptor ? (
                  <span className="mt-0.5 block text-sm leading-snug text-gray-500">
                    {resource.descriptor}
                  </span>
                ) : null}
              </a>
            )
          })}
        </div>
      </div>
    </section>
  )
}

export default Resources
